import { render, staticRenderFns } from "./GroupingSidebarMenu.vue?vue&type=template&id=87c897b4&scoped=true&"
import script from "./GroupingSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./GroupingSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./GroupingSidebarMenu.vue?vue&type=style&index=0&id=87c897b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c897b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87c897b4')) {
      api.createRecord('87c897b4', component.options)
    } else {
      api.reload('87c897b4', component.options)
    }
    module.hot.accept("./GroupingSidebarMenu.vue?vue&type=template&id=87c897b4&scoped=true&", function () {
      api.rerender('87c897b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/GroupingSidebarMenu.vue"
export default component.exports